export interface Provider {
  id: number;
  email: string;
  fullname: string;
  phone: string;
  isShippingCompany: boolean;
  isBrand: boolean;
}

export const STORAGE = "@Data-Provider";

export const getUser = () => {
  const user = localStorage.getItem(STORAGE);

  return JSON.parse(user as string);
};

export const setUser = (user: Provider) => {
  localStorage.setItem(STORAGE, JSON.stringify(user));
};

export const removeUser = () => {
  localStorage.removeItem(STORAGE);
};
